/*
 * Copyright (C) 2024 Reseau Concept.
 * https://reseau-concept.com
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideEffects } from '@ngrx/effects';
import { TranslateModule } from '@ngx-translate/core';

import { ExtensionService, provideExtensionConfig } from '@alfresco/adf-extensions';

import { CollaboraOnlineComponent } from './collabora-online.component';
import { canEditWithCollaboraOnline } from '../rules/evaluators';
import { CollaboraEffects } from '../effects/collabora-online.effects';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { ToolbarModule, PipeModule, ViewerModule, IconModule, provideTranslations } from '@alfresco/adf-core';
import { MatButtonModule } from '@angular/material/button';
import { ViewerCollaboraModule } from './viewer/viewer-collabora.module';

@NgModule({
  imports: [
    CollaboraOnlineComponent,
    MatIconModule,
    MatButtonModule,
    MatToolbarModule,
    PipeModule,
    ToolbarModule,
    ViewerModule,
    CommonModule,
    IconModule,
    // forRoot() ici ecrasait le TranslateLoader d'ADF (erreur runtime
    // "customLoader.setDefaultLang is not a function" avec ngx-translate 17).
    // Une extension consomme la configuration de traduction de l'application, elle ne la fournit pas.
    TranslateModule,
    ViewerCollaboraModule
  ],
  providers: [
    provideEffects([CollaboraEffects]),
    provideExtensionConfig(['collabora-online.plugin.json']),
    // Sans ce fournisseur, les cles `COLLABORA.*` n'etaient JAMAIS traduites : elles s'affichaient
    // telles quelles. ADF ne charge que les catalogues declares, et personne ne declarait celui de
    // cette extension. Le chemin donne ici est une base : ADF y cherche `i18n/<langue>.json`.
    //
    // D'ou le dossier dedie `assets/collabora-online` cote build, plutot que `assets/plugins` que
    // toutes les extensions se partagent — meme convention que `folder-rules` et `ms-office`.
    provideTranslations('collabora-online', 'assets/collabora-online')
  ]
})
export class CollaboraOnlineModule {
  constructor(extensions: ExtensionService) {
    extensions.setComponents({
      'collabora-online.main.component': CollaboraOnlineComponent
    });
    extensions.setEvaluators({
      'collabora.canEditWithCollaboraOnline': canEditWithCollaboraOnline
    });
  }
}
